import React from "react";
import { Col, Button } from "reactstrap";
import { getCookie } from "../jwt/_helpers/cookie";
import AsyncDropdownNormal from "./asyncDropdownNormal";

const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const SubUserFilter = ({ subUserData }) => {

  const token = getCookie("token");

  return (
    <>
    <Col>
        {
            subUserData.subUser ?
            <div className="releaseFileRow">
                <p className="releaseFileRowName"><b>Sub-User: </b> {subUserData.subUser}</p>
            </div>
            :
            <AsyncDropdownNormal
                endpoint="sub-users"
                subUserEndpoint=""
                parentUserOnly=""
                queryParams="&page=1&page_size=10"
                labelField="friendly_name"
                valueField="id"
                placeholder="Select Sub-User"
                fetchOptions={{
                  method: "GET",
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "x-api-key": X_API_KEY,
                    "Content-Type": "application/json",
                  },
                }}
                onChange={(subUserObj) => {
                    let friendlyName = subUserObj.label;
                    let subUserId = subUserObj.value;
                    if(subUserId !== '') {
                        subUserData.setSubUser(friendlyName);
                        subUserData.setSubUserEndpoint(`sub-user/${subUserId}/`);
                        subUserData.setParentUserOnly('');
                    }
                    else
                    {
                        subUserData.setSubUser('');
                        subUserData.setSubUserEndpoint('');
                        subUserData.setParentUserOnly('');
                    }
                }}
                className="artistType"
          />
        }
        </Col>
        <Col>
            {
                subUserData.subUser &&
                <Button className="btn btn-outline-info"
                    onClick={() => {
                        subUserData.setSubUser('');
                        subUserData.setSubUserEndpoint('');
                        subUserData.setParentUserOnly('');
                    }}
                >
                    Reset
                </Button>
            }
        </Col>
    </>
  );
};

export default SubUserFilter;
